import type { ReactNode } from 'react'

import { Typography } from 'antd'
import { isWithdrawnNickname } from '@repo/shared'

interface NicknameTextProps {
  /** 회원 닉네임 — 탈퇴 여부는 이 값으로만 판단한다. */
  nickname: string | null | undefined
  /** 보여 줄 내용이 닉네임과 다를 때(예: 닉네임이 없으면 사용자 ID 앞자리). 없으면 닉네임. */
  children?: ReactNode
}

/**
 * 회원 닉네임 표시 (개발항목 275).
 *
 * 탈퇴한 회원은 서버가 닉네임을 `원래닉네임(탈퇴)`로 바꿔 내려준다. 글자는 그대로 보여 주고, 탈퇴한
 * 회원이면 보조 글자색(회색)으로만 바꾼다 — 탈퇴 판단은 이 컴포넌트에서만 한다(`isWithdrawnNickname`).
 * 탈퇴하지 않은 회원은 감싸지 않아 링크·굵게 같은 바깥 스타일이 그대로 적용된다.
 */
export function NicknameText({ nickname, children }: NicknameTextProps): React.JSX.Element {
  const content = children ?? nickname
  if (isWithdrawnNickname(nickname)) {
    return (
      <Typography.Text type="secondary" data-testid="withdrawn-nickname">
        {content}
      </Typography.Text>
    )
  }
  return <>{content}</>
}
